module.exports = __webpack_public_path__ + "files/e09944861c802b3c730c408c227a3fa1.svg";